var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProofOfRecordLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10804_38037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 0.833984V2.50065M6.74965 3.25061L7.95799 2.04228M7.49967 5.00065H9.16634M6.74965 6.75063L7.95799 7.95896M4.99967 7.50065V9.16732M2.0413 7.95896L3.24963 6.75063M0.833008 5.00065H2.49967M2.0413 2.04228L3.24963 3.25061",
    stroke: "#64768B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10804_38037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfRecordLoading);
export default __webpack_public_path__ + "static/media/proof_of_record_loading.81370d9226fbfe5a9e1d65b0216a80d2.svg";
export { ForwardRef as ReactComponent };